<div class="feedback-dialog-container">
  <mat-dialog-content>
    <!-- Loading overlay -->
    <div class="loading-overlay" *ngIf="isSubmitting">
      <div class="loading-content">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Submitting feedback...</p>
      </div>
    </div>

    <div class="dialog-header">
      <h2 mat-dialog-title>{{ data.existingFeedback ? 'Edit Price Feedback' : 'Add Price Feedback' }}</h2>
      <button mat-icon-button (click)="onClose()" class="close-button" [disabled]="isSubmitting">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    
    <div class="dialog-body" [class.disabled-content]="isSubmitting">
      <div class="selected-items-info" *ngIf="selectedItems && selectedItems.length > 0">
        <p><strong>Selected Items ({{ selectedItems.length }}):</strong></p>
        <div class="selected-items-list">
          <mat-chip-set>
            <mat-chip *ngFor="let item of selectedItems">
              {{ item }}
            </mat-chip>
          </mat-chip-set>
        </div>
      </div>

      <div class="feedback-form">
        <mat-label><strong>Quality Confirmation: </strong>Does the model recommendation make sense? It is aligned with direction?</mat-label>
        <mat-form-field appearance="outline">
          <mat-select placeholder="Select" [(value)]="feedbackData.qualityConfirmation" required>
            <mat-option value="Yes">
              <mat-icon style="color: #4caf50; margin-right: 8px; vertical-align: middle;">check_circle</mat-icon>
              Yes
            </mat-option>
            <mat-option value="No">
              <mat-icon style="color: #f44336; margin-right: 8px; vertical-align: middle;">cancel</mat-icon>
              No
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-label><strong>Action Taken: </strong>Acceptance Objective: Was the forecast used to help influence, or inform a resulting decision/action that drives value?</mat-label>
        <mat-form-field appearance="outline">
          <mat-select placeholder="Select" [(value)]="feedbackData.action" (selectionChange)="onActionChange()" required>
            <mat-option [value]="FeedbackAction.ACCEPTED">
              <mat-icon style="color: #4caf50; margin-right: 8px; vertical-align: middle;">check_circle</mat-icon>
              Accept
            </mat-option>
            <mat-option [value]="FeedbackAction.REJECTED">
              <mat-icon style="color: #f44336; margin-right: 8px; vertical-align: middle;">cancel</mat-icon>
              Reject
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div *ngIf="feedbackData.action === FeedbackAction.REJECTED">
          <mat-label>Feedback Reason</mat-label>
          <mat-form-field appearance="outline">
            <mat-select placeholder="Select" [(value)]="feedbackData.type" required>
              <mat-option value="Market">Market</mat-option>
              <mat-option value="Demand">Demand</mat-option>
              <mat-option value="Pricing">Pricing</mat-option>
              <mat-option value="Supply">Supply</mat-option>
              <mat-option value="Other">Other</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      
        <mat-label>Comments</mat-label>
        <mat-form-field appearance="outline" class="full-width">
          <textarea 
            matInput 
            [(ngModel)]="feedbackData.comments" 
            placeholder="Please provide your feedback..."
            rows="4"
            required>
          </textarea>
          <mat-hint>Maximum 500 characters</mat-hint>
        </mat-form-field>
        <span>*This field is required to help understand your feedback</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onClose()" [disabled]="isSubmitting">Cancel</button>
    <button 
      mat-raised-button 
      color="primary" 
      id="feedback-submit-button"
      (click)="onSubmit()"
      [disabled]="!isFormValid() || isSubmitting">
      <mat-spinner diameter="20" *ngIf="isSubmitting" style="margin-right: 8px;"></mat-spinner>
      {{ isSubmitting ? 'Submitting...' : 'Submit' }}
    </button>
  </mat-dialog-actions>
</div>
